module.exports = __webpack_public_path__ + "img/l.c6dc7acc.jpg";